export const colors = {
  COLOR_BACKGROUND: '#202021',
  COLOR_GRAY: '#3D3D3E',
  COLOR_PRIMARY: '#2AB34B',
  COLOR_WHITE: 'white',
  COLOR_RED: '#BE202E',
  COLOR_GRAY_TEXT: '#808285',
  COLOR_GRAY_BUTTON: '#3D3D3E',
  COLOR_GRAY_BUTTON_OUTLINE: '#676767',
  COLOR_BACON_SAYS_TEXT: '#BCBEC0',
};